import { Heart, Users, UserCheck, Briefcase } from "lucide-react";

const audiences = [
  {
    icon: Heart,
    title: "Honeymoon & Couple Travelers",
    description: "Romantic getaways designed for newlyweds and couples seeking magical experiences.",
  },
  {
    icon: Users,
    title: "Families",
    description: "Kid-friendly vacations with activities for all ages and stress-free planning.",
  },
  {
    icon: UserCheck,
    title: "Senior Citizens",
    description: "Comfortable, relaxed tours with special care and accessible arrangements.",
  },
  {
    icon: Briefcase,
    title: "Corporate & Frequent Travelers",
    description: "Business travel support, MICE events, and loyalty benefits for regulars.",
  },
];

export const WhoWeServe = () => {
  return (
    <section className="section-padding bg-muted/30" aria-labelledby="who-we-serve-heading">
      <div className="container-luxury">
        <div className="text-center space-y-4 mb-14">
          <span className="section-badge">Who We Serve</span>
          <h2 id="who-we-serve-heading" className="section-title">
            Travel Solutions for Everyone
          </h2>
          <p className="section-subtitle">
            Whether you're planning a romantic honeymoon or a family adventure, we've got you covered.
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {audiences.map((audience, index) => (
            <div 
              key={index} 
              className="luxury-card p-8 text-center space-y-5 hover-lift"
            >
              <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto">
                <audience.icon className="h-8 w-8 text-primary" aria-hidden="true" />
              </div>
              <h3 className="font-heading font-semibold text-lg">{audience.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{audience.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};